import { createContextStore } from '@/shared/util/createContextStore';

export type SidebarTreeState = {
  selectedKey: string | undefined;
  selectedTime: number;
};

export type SidebarTreeAction = {
  setSelectedKey: (key: string) => void;
  getSelectedTime: () => number;
};

const [SidebarTreeStoreProvider, useSidebarTreeStore] = createContextStore<
  SidebarTreeState,
  SidebarTreeAction
>((set, get) => ({
  selectedKey: undefined,
  selectedTime: 0,
  setSelectedKey: (key) => {
    set((x) => ({
      ...x,
      selectedKey: key,
      selectedTime: new Date().getTime(),
    }));
  },
  getSelectedTime: () => {
    return get().selectedTime;
  },
}));

export { SidebarTreeStoreProvider, useSidebarTreeStore };
